import Location from './components/Location.vue';
import LocationByStep from './components/LocationByStep.vue';

const install = (Vue, options = {}) => {
	Vue.component('Location', Location);
	Vue.component('LocationByStep', LocationByStep);
};

Location.install = install;

if (typeof CitrusUi !== 'undefined' && CitrusUi.Vue) {
	CitrusUi.Vue.use(Location);
}

export default Location;
